import { useQuery } from "@apollo/client";
import { GET_PRODUCT_SUMMARY_DATA } from "../../../apollo/gql/query/productSummary.query";
import Header from "../../../components/Header";
import MyOrders from '../../../components/orders/my-orders';
import OrderDetails from '../../../components/orders/order-details';
import { useEffect, useState } from 'react';
import { Spinner } from "reactstrap";
import { isUserAdmin } from "../../../utils/utils";
import useCompanyId from "../../../hooks/useCompanyId";


const Orders = () => {

  const userDataJSON = localStorage.getItem('userData');
  const userData = userDataJSON ? JSON.parse(userDataJSON) : null;
  const [productSummary, setProductSummary] = useState<any>([])
  const [order, setOrder] = useState<any>()

  const { data: summaryData, loading: summaryLoading, refetch: refetchPricingData } = useQuery(GET_PRODUCT_SUMMARY_DATA, {
    variables: {
      isAdmin: isUserAdmin(),
      customerId: !isUserAdmin() ? userData?._id : "",
    },
    fetchPolicy: 'cache-and-network'
  })

  useEffect(() => {
    if (summaryData && summaryData.getProductSummary) {
      setProductSummary(summaryData.getProductSummary)
      if (!order) {
        setOrder(summaryData.getProductSummary[0])
      } else {
        const newData = summaryData?.getProductSummary?.find((data: any) => data?._id === order?._id)
        if (newData) {
          setOrder(newData)
        }
      }
    }
  }, [summaryData])

  return (
    <>
      <Header />
      {!productSummary.length && !summaryLoading ?
        <div className="h-screen flex flex-col items-center justify-center">No order found.</div>
        : <div className='bg-gray-100'>
          <div className='p-10'>
            {!productSummary.length && summaryLoading ? <div
            className="h-screen flex flex-col items-center justify-center"
            >
              <Spinner size="bg" className='mt-3 w-10 h-10'> </Spinner>
            </div> :
              <div className='grid grid-cols-12 gap-4'>

                <div className='col-span-12 lg:col-span-3'><MyOrders productSummary={productSummary} setOrder={setOrder} /></div>
                <div className='col-span-12 lg:col-span-9'><OrderDetails order={order} refetch={refetchPricingData} /></div>
              </div>
            }
          </div>
        </div>}
    </>
  )
}
export default Orders;